import { loading } from 'State/actions';
import * as types from './types';

export const generateReport = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROHIBITED_ITEMS_REPORT_REPORT_LOADING, true));

    try {
      const { page: { students, siteId } } = getState().ProhibitedItemsState;
      const response = await MPWWebApi.postGenericInsertUpdate(
        'reports/prohibiteditems',
        {
          selectedStudents: students.filter(s => s.Checked).map(s => s.IdSeed),
          siteId,
        }
      );
      dispatch({
        type: types.PROHIBITED_ITEMS_REPORT_GENERATE_REPORT,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.PROHIBITED_ITEMS_REPORT_REPORT_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.PROHIBITED_ITEMS_REPORT_REPORT_LOADING, false));
  };
};

export const clearReport = () => {
  return { type: types.PROHIBITED_ITEMS_REPORT_CLEAR_REPORT };
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/report/actions.js